import type React from 'react';

import type { Row, RowData } from '@tanstack/react-table';
import { Checkbox } from '@vlabs/uikit/components/controls/checkbox/Checkbox';
import type { WithDataTestid } from '@vlabs/uikit/types';

import { buildTableViewCell } from './buildTableViewCell';
import { buildTestid } from '../../../lib/utils';

export interface SelectCellProps<TData extends RowData> extends WithDataTestid {
  row: Row<TData>;
}

const displayName = 'SelectCell';
const testid = buildTestid(displayName);

function SelectCell<TData extends RowData>({
  row,
  'data-testid': dataTestId = undefined,
}: SelectCellProps<TData>): React.JSX.Element {
  return buildTableViewCell({
    ...testid(row.id, dataTestId),
  })(
    <Checkbox
      checked={row.getIsSelected()}
      disabled={!row.getCanSelect()}
      indeterminate={row.getIsSomeSelected()}
      onChange={row.getToggleSelectedHandler()}
      {...testid('SelectRowCheckbox', row.id, dataTestId)}
    />,
  );
}

export { SelectCell };
